// extracted by mini-css-extract-plugin
export default {"countdown":"Countdown_countdown__cQy7J","pulse":"Countdown_pulse__EGaeI"};